export default "__VITE_ASSET__DtSMZaBk__"